"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _axios = _interopRequireDefault(require("axios"));

var _reactToastify = require("react-toastify");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledButton = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: inherit;\n  font-family: ", ";\n  padding: 0.5rem 0;\n  margin-bottom: 1rem;\n  color: ", ";\n"])), function (p) {
  return p.theme.inputFontFamily;
}, function (props) {
  return props.theme.colorAccent;
});

var visibleWrapperStyles = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  opacity: 1;\n  visibility: visible;\n"])));

var StyledModalWrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 7;\n  top: 50%;\n  left: 50%;\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(-50%, -50%);\n  transition-property: opacity, visibility;\n  transition-duration: 0.35s;\n\n  ", ";\n"])), function (p) {
  return p.isVisible && visibleWrapperStyles;
});

var visibleModalStyles = (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  transform: translateY(0);\n"])));

var StyledModal = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background: white;\n  border-radius: 0.5rem;\n  padding: 1rem 0;\n  transform: translateY(2rem);\n  transition: transform 0.35s;\n\n  ", ";\n"])), function (p) {
  return p.isVisible && visibleModalStyles;
});

var StyledHeader = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 0 1rem 1rem;\n"])));

var StyledCloseButton = _styledComponents.default.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([""])));

var StyledText = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-right: 2rem;\n  line-height: 1.1875rem;\n  font-weight: 400;\n  font-family: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
});

var StyledButtons = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 0 1rem;\n"])));

var LoginResetPin = function LoginResetPin(_ref) {
  var translations = _ref.translations,
      onError = _ref.onError,
      dpgUserId = _ref.dpgUserId;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isConfirming = _useState2[0],
      setConfirming = _useState2[1];

  var reset = function reset() {
    setConfirming(true);
  };

  var cancel = function cancel() {
    setConfirming(false);
  };

  var confirmReset = function confirmReset() {
    _axios.default.post("/dpg-pin/reset", {
      dpgUserId: dpgUserId
    }).then(function () {
      setConfirming(false);

      _reactToastify.toast.success("".concat(translations.pin, " ").concat(translations.sent));
    }).catch(function (error) {
      setConfirming(false);
      onError(error);
    });
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Overlay, {
    zIndex: 4,
    isVisible: isConfirming,
    onClick: cancel
  }), /*#__PURE__*/_react.default.createElement(StyledModalWrapper, {
    isVisible: isConfirming
  }, /*#__PURE__*/_react.default.createElement(StyledModal, {
    isVisible: isConfirming
  }, /*#__PURE__*/_react.default.createElement(StyledHeader, null, /*#__PURE__*/_react.default.createElement(StyledText, null, translations.confirmResetPin), /*#__PURE__*/_react.default.createElement(StyledCloseButton, {
    onClick: cancel
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, null, "close"))), /*#__PURE__*/_react.default.createElement(StyledButtons, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    onClick: cancel,
    style: {
      marginRight: "0.25rem"
    },
    isDefault: true,
    size: "sm"
  }, translations.cancel), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    onClick: confirmReset,
    style: {
      marginLeft: "0.25rem"
    },
    isPrimary: true,
    size: "sm"
  }, translations.confirm)))), /*#__PURE__*/_react.default.createElement(StyledButton, {
    type: "button",
    onClick: reset
  }, translations.sendMyPin));
};

var _default = LoginResetPin;
exports.default = _default;